import { Injectable } from '@angular/core';
import {Subject} from 'rxjs';

@Injectable()
export class ModalVisibilityService {

    private closeEditDialogModalsRequestSource = new Subject();
    private closeProjectListPageModalsRequestSource: Subject<void> = new Subject();

    public closeEditDialogModalsRequestAnnounced$ = this.closeEditDialogModalsRequestSource.asObservable();
    public closeProjectListPageModalsRequestAnnounced$ = this.closeProjectListPageModalsRequestSource.asObservable();

    public announceCloseEditDialogModalsRequest( source?: string) {
        this.closeEditDialogModalsRequestSource.next(source);
    }

    public announceCloseProjectsListPageModalsRequest() {
        this.closeProjectListPageModalsRequestSource.next();
    }

}
